import { Pipe, PipeTransform } from '@angular/core';
import { BehaviorSubject, fromEvent, merge, Observable } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';

@Pipe({
    name: 'keyboardStatus',
    standalone: true,
    pure: false,
})
export class KeyboardStatusPipe implements PipeTransform {
    private keyboardOpen$ = new BehaviorSubject<boolean>(false);

    constructor() {
        merge(
            fromEvent(document, 'focusin'),
            fromEvent(document, 'focusout'),
            fromEvent(window, 'click') // handles taps that may blur
        )
            .pipe(
                debounceTime(100),
                map(() => {
                    const tag = document.activeElement?.tagName || '';
                    return ['TEXTAREA'].includes(tag);
                }),
                startWith(false)
            )
            .subscribe(this.keyboardOpen$);
    }

    transform(_: any): Observable<boolean> {
        return this.keyboardOpen$.asObservable();
    }
}
